'use client';

import { usePathname, useRouter, redirect } from 'next/navigation';
import Link from 'next/link';
// Обертка для Link
const LinkWithPrefetch = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & any) => {
  return (
    <Link prefetch={true} {...props} href={props.href}>
      {children}
    </Link>
  );
};

// Экспортируйте обертку
export { LinkWithPrefetch as Link, redirect, usePathname, useRouter };
